import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function removeItem(view, wishlistId, item, wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of removeItem()');
    invariant(brandId, 'brandId is a required param of removeItem()');
    invariant(country, 'country is a required param of removeItem()');
    invariant(item, 'item is a required param of removeItem()');
    invariant(uberToken, 'uberToken is a required param of removeItem()');
    invariant(clientId, 'clientId is a required param of removeItem()');

    const headers = { 'Content-Type': 'application/json' };

    let optionalQuery;

    if (view === 'ALL_ITEMS') {
        optionalQuery = `items/${item}`;
    } else if (view === 'INVENTORY') {
        optionalQuery = `${wishlistId}?itemId=${item}`;
    } else {
        optionalQuery = `items/${item}?wishlistId=${wishlistId}`;
    }

    const deleteURl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/${optionalQuery}`;

    return labelRequest(
        authenticatedRequest(new Request(deleteURl, { headers: new Headers(headers), method: 'DELETE' }), uberToken, clientId, clientSecret),
        'removeItem',
    );
}
